<template lang="pug"></template>
<script>
import { defineComponent, onMounted} from 'vue';
import { useRouter } from 'vue-router';


export default defineComponent({
    name: 'HomePage',
    props: {
        fetchBox: Object,
        maintenanceModel:Object,
        userModel: Object,
    },
    setup(props) {
        const router = useRouter();

        function checkCookie () {
            const checkCookieArr = new FormData();
            const cookieUrl = 'login.php'; 

            checkCookieArr.append('status', 'checkCookie');
            if (props.fetchBox) {
                (async () => {
                    const result = await props.fetchBox.fetchData(cookieUrl, checkCookieArr, 'checkCookie');
                    if (result.processResponse === true) {
                        if (result.cookie === true) {
                            props.userModel.userId = result.userData.id;
                            props.userModel.userStatus = result.userData.status;
                            props.userModel.userName= result.userData.name;
                            props.userModel.userCompany = result.userData.company;
                            props.userModel.userEmail  = result.userData.email;
                            props.userModel.userLogin  = 1;
                            props.userModel.userMaintenanceAdmin  = result.userData.maintenanceAdmin;
                            props.userModel.userSignatur  = result.userData.signature;

                            router.push('/search');
                        } else {
                            router.push('/login');
                        }
                    }
                })();
            } else { console.warn("ref <HomePage>: fetchBox not available => line 47"); }



            //     var checkCookieArr = new FormData();
            // checkCookieArr.append('status', 'checkCookie');
            // var url = 'login.php'; 
            // layerShow.value = true;
            // layerType.value = 'wait';
            // layerError.value = true;
            // waitBoxText.value = 2;
            // fetchBox.value.fetchData(url, checkCookieArr, 'check Cookie').then(response => {
            //     if (response.processResponse === true) {
            //         layerShow.value = false;
            //         if (response.cookie === true) {
            //             var setSession = false;
            //             var urlParam = window.location.search;
            //             var urlParams = new URLSearchParams(urlParam);

            //             if (response.maintenanceStatus === 1) {
            //                 sessionStorage.setItem('wnPortal_maintenance', true);
            //                 if (response.maintenancePermission === true) {
            //                     setSession = true;
            //                 } else {
            //                     if (urlParams && (urlParams.get('status') === "maintenance") && (urlParams.get('shortId') === response.maintenanceShortId)) {
            //                         return true;
            //                     } else {
            //                         sessionStorage.clear();
            //                         document.cookie = 'wnLoginId' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            //                         document.cookie = 'wnUserLogin' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            //                         window.location.href = 'index.php';
            //                     }
            //                 }
            //             } else {
            //                 setSession = true;
            //             }

            //             if (setSession === true) {
            //                 sessionStorage.setItem('wnPortal_LoginStatus', true);
            //                 sessionStorage.setItem('wnPortal_username', response.userData.name);
            //                 sessionStorage.setItem('wnPortal_status', response.userData.status);
            //                 sessionStorage.setItem('wnPortal_userId', response.userData.id);
            //                 sessionStorage.setItem('wnPortal_company', response.userData.company);
            //                 sessionStorage.setItem('wnPortal_email', response.userData.email);
            //                 sessionStorage.setItem('wnPortal_login', true);
            //                 sessionStorage.setItem('wnPortal_maintenanceAdmin', response.userData.maintenanceAdmin); 
            //                 sessionStorage.setItem('wnPortal_csv2pdf', response.userData.csv2pdf);
            //                 window.location.href = 'search.php';
            //             }
            //         } else {
            //             return true;
            //         }
            //     }
            // });


        }

        onMounted(() => {
            checkCookie();
        });
        return {
            router,
            checkCookie
        };
    }
});
</script>